import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { fontWeights } from "et3-ui-library";

import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import KhattabatMatchingFamilyFilters from "./KhattabatMatchingFamilyFilters";
import KhattabatMatchingLifestyleFilters from "./KhattabatMatchingLifestyleFilters";
import KhattabatMatchingLocationFilters from "./KhattabatMatchingLocationFilters";
import KhattabatMatchingRangeFilters from "./KhattabatMatchingRangeFilters";

const Form = withLiteObserverAndTheme(() => {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography
        variant="subtitle1"
        fontWeight={fontWeights.semibold}
        sx={{ mb: 2 }}
      >
        {i18n.get("FILTERS")}
      </Typography>
      <Grid container spacing={2}>
        <KhattabatMatchingRangeFilters />
        <KhattabatMatchingLocationFilters />
        <KhattabatMatchingFamilyFilters />
        <KhattabatMatchingLifestyleFilters />
      </Grid>
    </Paper>
  );
});

export default Form;
